import { useState } from 'react';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { IAPIError } from '../interface/common';
import { useApiErrorModal } from './useApiErrorModal';
import { getTaskCreationFieldError, ITaskFieldError } from '../helpers/taskCreationErrorHelper';

export const useTaskSubmissionError = () => {
  const { t } = useTranslation();
  const [fieldError, setFieldError] = useState<ITaskFieldError | null>(null);
  const { isErrorModalVisible, errorMessage, showErrorModal, closeErrorModal } = useApiErrorModal(
    () => t('common:somethingWentWrongTryAgain'),
  );

  const clearFieldError = () => setFieldError(null);

  const showSubmissionError = (error: unknown) => {
    const resolvedFieldError = isAxiosError<IAPIError>(error)
      ? getTaskCreationFieldError(t, error.response?.data?.type)
      : null;
    // Failures that belong to a field are shown next to it; the rest have nothing to point at
    // and keep using the modal.
    if (resolvedFieldError) {
      setFieldError(resolvedFieldError);
      return;
    }
    showErrorModal(error);
  };

  return {
    fieldError,
    clearFieldError,
    showSubmissionError,
    isErrorModalVisible,
    errorMessage,
    closeErrorModal,
  };
};
